import BaseStore from "../base/BaseStore";
import { ActionInterface, StoreActionType } from "../constant/ActionConstant";
import AppDispatcher from "../dispatcher/AppDispatcher";
import Service from "../model/service/Service";

class DeliverooStore extends BaseStore {

    private _service: Service

    constructor() {
        super();
        this._service = new Service();
    }

    public get service(): Service {
        return this._service;
    }

    setService(service: Service) {
        this._service = service;
        this.emitChange();
    }

}

const storeActions = (store: DeliverooStore) => {
    return (action: ActionInterface) => {
        switch(action.type) {
            case StoreActionType.SET_DELIVEROO_SERVICE:
                store.setService(action.data);
                break;
        }
    }
};

const deliverooStoreShared = new DeliverooStore();
deliverooStoreShared.dispatchToken = AppDispatcher.register(storeActions(deliverooStoreShared) as (payload: unknown) => void);

export default deliverooStoreShared;
export const store = DeliverooStore;
export const action = storeActions;